import * as React from 'react';
import BaseComponent from '../BaseComponent';
import {Button, Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Modal, Row} from "reactstrap";
import modelImageDefault from '../../assets/img/banner/rack.png';
import HorizontalLine from "../Widget/HorizontalLine";
import * as PropTypes from 'prop-types';
import {DD_MM_YYYY_HH_MM_SS} from "../../utils/Global";
// import label from "../../message/Label"
import label from 'enqc-utilities/src/label/Label'

import {parseDate} from "../../utils/Utilities";
import MyCardImage from "../Card/MyCardImage";
import {ASSEMBLY_STATUS_COLOR} from "enqc-utilities/src/utils/Global";
import {MdClose, MdWarning} from "react-icons/all";
import AssemblyStatusMessageCard from "../Card/AssemblyStatusMessageCard";

// const serialNumberOrReferenceRef = useRef(null)

/*= (message, okCallback, cancelCallback) =>*/
export default class AssemblyDetailModal extends BaseComponent{


    render(){
        let {assembly, show, onContinueInspection, onClose, onUpdateIntention} = this.props
        if(!onClose){
            onClose = () => {}
        }
        if(!onContinueInspection){
            onContinueInspection = () => {}
        }
        if(!onUpdateIntention){
            onUpdateIntention = () => {}
        }

        let {model} = assembly
        if(!model){
            model = {};
        }
        let {modelCategory} = model
        if(!modelCategory){
            modelCategory = {}
        }
        let {assemblyStatus} = assembly
        if(!assemblyStatus){
            assemblyStatus = {}
        }
        let {statusMessage} = assembly

        let {user} = assembly
        if(!user){
            user = {}
        }
        let userManufacturingSite = user.manufacturingSite?user.manufacturingSite:{}
        let {creator} = assembly
        if(!creator){
            creator = {}
        }
        let creatorManufacturingSite = creator.manufacturingSite?creator.manufacturingSite:{}

        let {serialComponent} = assembly
        if(!serialComponent){
            serialComponent = {}
        }
        let {components} = serialComponent
        if(!components) {
            components = []
        }

        let {rectifierControllerEntry} = assembly
        if(!rectifierControllerEntry){
            rectifierControllerEntry = {}
        }
        let {rectifierControllerSerialNumbers} = rectifierControllerEntry
        if(!rectifierControllerSerialNumbers) {
            rectifierControllerSerialNumbers = []
        }


        return (
            /*xl-lg-sm*/
            <>
                {super.render()}
                <Modal
                    autoFocus={false}
                    size="xl"
                    centered={true}
                    isOpen={show}
                    backdrop={true}>
                    <Card>
                        <CardHeader>
                            <Row>
                                <Col>
                                    <span style={{fontSize:'26px', fontWeight:'bold'}}>{label.AssemblyDetail}</span>
                                </Col>
                                <Col className="float-right">
                                    <Button color="white" className="float-right btn-outline-black" onClick={event=>{
                                        onClose()
                                    }}>{label.Close}&nbsp;<MdClose/></Button>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col md={4} style={{textAlign:'left'}}>
                                    <Row>
                                        <Col>
                                            <Card>
                                                <CardBody className="text-center">
                                                    <Row>
                                                        <Col>
                                                            <div style={{textAlign:'center'}}>
                                                                <MyCardImage
                                                                    style={{width:'80%'}}
                                                                    src={model.iconPhoto?model.iconPhotoUrl:modelImageDefault}
                                                                    onError={(elm)=>this.defaultImage(elm, modelImageDefault)}
                                                                />
                                                            </div>
                                                            <HorizontalLine/>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            {label.Model}
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <span className="bold font-medium text-danger"><h4>{model.systemType}</h4></span>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            {label.PartNumber}
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <span className="bold font-small text-success"><h4>{model.partNumber}</h4></span>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            {label.Category}
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <span className="font-weight-bolder font-medium"><h5>{modelCategory.name}</h5></span>
                                                        </Col>
                                                    </Row>
                                                    <br/>
                                                    <HorizontalLine className="p-0 m-0"/>
                                                    <Row className="p-2 justify-content-center align-content-center align-items-center" style={{backgroundColor:ASSEMBLY_STATUS_COLOR[assemblyStatus.name]}}>
                                                        <Col className="d-grid p-1">
                                                            <span className="bold">
                                                                <h3 className="text-light p-1">{assemblyStatus.label}</h3>
                                                            </span>
                                                            <Button
                                                                className="w-100 btn-outline-danger btn-light text-dark"
                                                                onClick={(e) => {
                                                                    e.preventDefault()
                                                                    onUpdateIntention(assembly)
                                                                }}>
                                                                {label.Update}&nbsp;<MdWarning/>
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                    <HorizontalLine className="p-0 m-0"/>
                                                    <br/>
                                                    <Row>
                                                        <Col>
                                                            {label.Reference}
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <span className="bold font-medium text-success"><h3>{assembly.reference}</h3></span>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            {label.Creator}
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <span className="font-weight-bolder font-medium"><h4>{creator.firstname}/{creatorManufacturingSite.name}</h4></span>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            {parseDate(assembly.created, DD_MM_YYYY_HH_MM_SS)}
                                                        </Col>
                                                    </Row>
                                                    <br/>
                                                    <Row>
                                                        <Col>
                                                            {label.LastPerformer}
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <span className="font-weight-bolder font-medium"><h4>{user.firstname}/{userManufacturingSite.name}</h4></span>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            {parseDate(assembly.updated, DD_MM_YYYY_HH_MM_SS)}
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={8}>
                                    <Row>
                                        <Col>
                                            <Card>
                                                <CardHeader>{label.FWVersion} {label.And} {label.Controller}</CardHeader>
                                                <CardBody>
                                                    <Row>
                                                        <Col xs={12} lg={6} className="text-left">
                                                            <Input
                                                                label={label.FWVersion}
                                                                readOnly={true}
                                                                value={assembly.fwVersion}
                                                            />
                                                        </Col>
                                                        <Col xs={12} lg={6} className="text-left">
                                                            <Input
                                                                label={label.Controller}
                                                                readOnly={true}
                                                                value={assembly.controller}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                    {
                                        assemblyStatus&&(
                                            <React.Fragment>
                                                <br/>
                                                <Row>
                                                    <Col md={12}>
                                                        <AssemblyStatusMessageCard
                                                            assembly={assembly}/>
                                                    </Col>
                                                </Row>
                                            </React.Fragment>
                                        )
                                    }
                                    <br/>
                                    <Row>
                                        <Col>
                                            <Card>
                                                <CardHeader>
                                                    {label.SerialComponent}
                                                </CardHeader>
                                                <CardBody>
                                                    <Row>
                                                        {components.map((item, index)=>{
                                                            return (
                                                                <Col md={6} sm={12}>
                                                                    <FormGroup>
                                                                        <Label>{item.label}</Label>
                                                                        <Input disabled type="text" value={item.value}/>
                                                                    </FormGroup>
                                                                </Col>
                                                            )
                                                        })}
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row>
                                        <Col>
                                            <Card>
                                                <CardHeader>
                                                    {label.RectifierSerialNumber}
                                                </CardHeader>
                                                <CardBody>
                                                    <Row>
                                                        {rectifierControllerSerialNumbers.map((item, index)=>{
                                                            return (
                                                                <Col md={6} sm={12}>
                                                                    <FormGroup>
                                                                        <Label>{item.indexOrder}</Label>
                                                                        <Input disabled type="text" value={item.serialCode}/>
                                                                    </FormGroup>
                                                                </Col>
                                                            )
                                                        })}
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Modal>
            </>
           )
    }
}

AssemblyDetailModal.propTypes = {
    show:PropTypes.bool.isRequired,
    assembly : PropTypes.object.isRequired,
    onUpdateIntention: PropTypes.func,
    onContinueInspection:PropTypes.func.isRequired,
    onClose:PropTypes.func.isRequired
}
